export default __webpack_public_path__ + "static/media/undraw_Responsive_re_e1nn.8bf29603.svg";